import styled from 'styled-components'
import { Typography } from 'antd'

export enum weight {
    Light = 300,
    Regular = 400,
    Medium = 500,
    SemiBold = 600,
    Bold = 700,
    ExtraBold = 800,
}

export type fontWeight = 'Light' | 'Regular' | 'Medium' | 'SemiBold' | 'Bold' | 'ExtraBold'

const { Title, Text, Paragraph } = Typography

const requiredAfterCss: Partial<React.CSSProperties> = {
    display: 'inline-block',
    marginLeft: 4,
    color: '#ff4d4f',
    lineHeight: 1,
    content: `"*"`,
}

type TypographyExtraProps = {
    textAlign?: React.CSSProperties['textAlign']
    required?: boolean
    textEllipsis?: boolean
    fontFamily?: 'Prompt' | 'THSarabunNew' | 'Sarabun' | 'inherit'
    fontWeight?: fontWeight
    fontSize?: number
    color?: string
    [key: string]: any
}

type TypographyExtraTitleProps = {
    textAlign?: React.CSSProperties['textAlign']
    required?: boolean
    textEllipsis?: boolean
    fontFamily?: 'Prompt' | 'THSarabunNew'
    fontWeight?: fontWeight
    fontSize?: number
    color?: string
    [key: string]: any
}

export const StyledTypographyTitle = styled(Title)<{
    styled?: TypographyExtraTitleProps
}>(({ styled }) => {
    if (styled) {
        const { fontFamily = 'Prompt', fontWeight = 'Bold', color = 'black', fontSize } = styled
        let textEllipsisStyle = styled.textEllipsis
            ? ({
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
              } as Partial<React.CSSProperties>)
            : {}

        if (fontWeight) {
            //@ts-ignore
            styled.fontWeight = weight[fontWeight]
        }

        if (fontSize !== undefined) {
            //@ts-ignore
            styled.fontSize = `${fontSize}px !important`
        }

        return {
            ...styled,
            textAlign: styled.textAlign || 'left',
            '&:after': styled.required ? requiredAfterCss : undefined,
            color: `${color} !important`,
            fontFamily,
            ...textEllipsisStyle,
        } as Partial<React.CSSProperties>
    }
})

//@ts-ignore
export const StyledTypographyText = styled(Text)<{ styled?: TypographyExtraProps }>(({ styled }) => {
    if (styled) {
        const { fontFamily = 'Prompt', fontWeight = 'Medium', fontSize, color = '#8A8A8A' } = styled

        let textEllipsisStyle = styled.textEllipsis
            ? ({ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' } as Partial<React.CSSProperties>)
            : {}

        let fontWeightNumber = fontWeight
        if (fontWeight) {
            //@ts-ignore
            fontWeightNumber = weight[fontWeight]
        }

        if (fontSize !== undefined) {
            //@ts-ignore
            styled.fontSize = `${fontSize}px !important`
        }

        return {
            color: `${color} !important`,
            fontSize: styled.fontSize,
            fontFamily,
            fontWeight: fontWeightNumber,
            textAlign: styled.textAlign || 'left',
            '&:after': styled.required ? requiredAfterCss : undefined,
            ...styled,
            ...textEllipsisStyle,
        } as Partial<React.CSSProperties>
    }
})

export const StyledTypographyParagraph = styled(Paragraph)<{ styled?: TypographyExtraProps }>(({ styled }) => {
    if (styled) {
        const { fontWeight } = styled

        let textEllipsisStyle = styled.textEllipsis
            ? ({ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' } as Partial<React.CSSProperties>)
            : {}

        // let fontWeightNumber = fontWeight
        if (fontWeight !== undefined) {
            //@ts-ignore
            styled.fontWeight = weight[fontWeight]
        }

        return {
            ...styled,
            textAlign: styled.textAlign || 'left',
            '&:after': styled.required ? requiredAfterCss : undefined,
            ...textEllipsisStyle,
        } as Partial<React.CSSProperties>
    }
})

export const StyledLabelField = styled(StyledTypographyText)({
    color: '#8A8A8A',
    fontWeight: weight.Regular,
    fontSize: '14px',
    float: 'left',
    letterSpacing: '0.12px',
})

export const StyledTypographyTitleFullPreview = styled(Title)<{
    styled?: TypographyExtraTitleProps
}>(({ styled }) => {
    if (styled) {
        const { fontFamily = 'THSarabunNew', fontWeight = 'Bold', color = 'black', fontSize } = styled
        let textEllipsisStyle = styled.textEllipsis
            ? ({
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
              } as Partial<React.CSSProperties>)
            : {}

        if (fontWeight) {
            //@ts-ignore
            styled.fontWeight = weight[fontWeight]
        }

        if (fontSize !== undefined) {
            //@ts-ignore
            styled.fontSize = `${fontSize}px !important`
        }

        return {
            ...styled,
            textAlign: styled.textAlign || 'left',
            '&:after': styled.required ? requiredAfterCss : undefined,
            color: `${color} !important`,
            fontFamily,
            ...textEllipsisStyle,
        } as Partial<React.CSSProperties>
    }
})

export const StyledTypographyTextFullPrevew = styled(Text)<{ styled?: TypographyExtraProps }>(({ styled }) => {
    if (styled) {
        const { fontFamily = 'THSarabunNew', fontWeight = 'Medium', fontSize = 20, color = '#8A8A8A' } = styled

        let textEllipsisStyle = styled.textEllipsis
            ? ({ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' } as Partial<React.CSSProperties>)
            : {}

        let fontWeightNumber = fontWeight
        if (fontWeight) {
            //@ts-ignore
            fontWeightNumber = weight[fontWeight]
        }

        if (fontSize !== undefined) {
            //@ts-ignore
            styled.fontSize = `${fontSize}px !important`
        }

        return {
            color: `${color} !important`,
            fontSize: styled.fontSize,
            fontFamily,
            fontWeight: fontWeightNumber,
            textAlign: styled.textAlign || 'left',
            '&:after': styled.required ? requiredAfterCss : undefined,
            ...styled,
            ...textEllipsisStyle,
        } as Partial<React.CSSProperties>
    }
})
